module.exports = __webpack_public_path__ + "static/assets/fb356e819d8ab210a241ce81b9bac33c.png";